import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';

const handleQuery = (style) => {
  return `
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};

  `;
};

export const Container = styled.div`
  display: grid;
  grid-template-columns: 45% 45%;
  justify-content: space-between;
  margin-top: 16px;

  ${handleQuery(css`
    display: flex;
    flex-direction: column;
  `)}
`;

export const ContentBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const BarsSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  ${handleQuery(css`
    flex-direction: column;
    align-items: flex-start;
  `)}
`;

export const Bar = styled.div`
  width: 45%;
  ${handleQuery(css`
    width: 100%;
  `)}
`;
